import TrainingMenuButton from './TrainingMenuButton'

export default TrainingMenuButton
